import { MulticastDelegate } from '../Core/MulticastDelegate';
import { properties } from '../Core/Properties';

export default class WindowResizeHelper {
    private static readonly onResize = MulticastDelegate.create<IHandler>();

    static initialize(): void {
        const jqWindow = $(window);

        if (properties.isPrint) {
            return;
        }

        if (!properties.isAndroid) {
            let resizing = false;

            jqWindow.on('resize', e => {
                if (!resizing && (e.target as any) == window) {
                    resizing = true;
                    setTimeout(() => {
                        this.onResize();
                        resizing = false;
                    }, 250);
                }
            });
        }

        if (properties.hasOrientationChange) {
            jqWindow.on('orientationchange', () => {
                jqWindow.one('resize', () => {
                    this.onResize();
                });
            });
        }
    }

    static on(fn: any): void {
        if (_.isFunction(fn)) {
            this.onResize && this.onResize.add(fn);
        }
    }

    static off(fn: any): void {
        if (_.isFunction(fn)) {
            this.onResize && this.onResize.remove(fn);
        }
    }
}
